var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-main",class:{ 'header-main-mobile': _vm.isMobile }},[_c('div',{staticClass:"header-width"},[_c('TheLogo'),(_vm.isMobile)?_c('TheDropdown'):_c('TheMenus')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }